import { Cursors, DRAG, DRAG_END, DRAG_START } from './../../constants';
/**
 * The tool handling the transformations via the adorner.
 *
 * @type {*}
 */
export class PointerTool {
    constructor(toolService) {
        this.toolService = toolService;
    }
    tryActivate() {
        return true; // the pointer tool is last and handles all others requests.
    }
    start(point, meta, nativeEvent) {
        const toolService = this.toolService, diagram = toolService.diagram, hoveredItem = toolService.hoveredItem;
        if (hoveredItem) {
            toolService.selectSingle(hoveredItem, meta);
            if (hoveredItem.adorner) { // connection
                this.adorner = hoveredItem.adorner;
                this.handle = this.adorner._hitTest(point);
            }
        }
        if (!this.handle) {
            this.handle = diagram._resizingAdorner._hitTest(point);
            if (this.handle) {
                this.adorner = diagram._resizingAdorner;
            }
        }
        if (this.adorner) {
            if (!this.adorner.isDragHandle(this.handle) || !diagram.trigger(DRAG_START, { shapes: this.adorner.shapes, connections: [], point, nativeEvent, meta })) {
                this.adorner.start(point);
            }
            else {
                toolService.startPoint = point;
                toolService.end(point, meta, nativeEvent);
            }
        }
    }
    move(point, meta, nativeEvent) {
        if (this.adorner) {
            this.adorner.move(this.handle, point);
            if (this.adorner.isDragHandle(this.handle)) {
                this.toolService.diagram.trigger(DRAG, { shapes: this.adorner.shapes, connections: [], point, meta, nativeEvent });
            }
        }
    }
    end(point, meta, nativeEvent) {
        const diagram = this.toolService.diagram, adorner = this.adorner;
        let unit;
        if (adorner) {
            if (!adorner.isDragHandle(this.handle) || !diagram.trigger(DRAG_END, { shapes: adorner.shapes, connections: [], point, meta, nativeEvent })) {
                unit = adorner.stop();
                if (unit) {
                    diagram.undoRedoService.add(unit, false);
                }
            }
            else {
                adorner.cancel();
            }
        }
        this.adorner = undefined;
        this.handle = undefined;
    }
    getCursor(p) {
        return this.toolService.hoveredItem ? this.toolService.hoveredItem._getCursor(p) : Cursors.arrow;
    }
}
